import React, { useState } from 'react';
import BlockContent from "../BlockContent";

const LeftSidebar = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedSections, setExpandedSections] = useState({
    recentEvents: true,
    upcomingEvents: false
  });

  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const openVideo = () => {
    setIsVideoOpen(true);
    setIsVideoLoading(true); // start loader
  };

  const closeVideo = () => {
    setIsVideoOpen(false);
    setIsVideoLoading(false);
  };

  // Tournament data sorted by date in ascending order
  const recentEvents = [
    {
      id: 1,
      date: "September 11-14",
      name: "Procore Championship",
      location: "Silverado Resort (North Course), Napa, California",
      status: "completed"
    },
    {
      id: 2,
      date: "September 26-28",
      name: "Ryder Cup",
      subtitle: "(unofficial team event on PGA Tour list)",
      location: "Bethpage State Park, Black Course, Farmingdale, New York",
      status: "completed"
    },
    {
      id: 3,
      date: "October 2-5",
      name: "Sanderson Farms Championship",
      location: "The Country Club of Jackson, Jackson, Mississippi",
      status: "completed"
    }
  ];

  const upcomingEvents = [
    {
      id: 4,
      date: "October 9-12",
      name: "Hero World Challenge",
      location: "Albany, Bahamas",
      status: "upcoming"
    },
    {
      id: 5,
      date: "October 16-19",
      name: "Grant Thornton Invitational",
      location: "Tiburón Golf Club, Naples, Florida",
      status: "upcoming"
    },
    {
      id: 6,
      date: "October 23-26",
      name: "World Wide Technology Championship",
      location: "El Cardonal at Diamante, Cabo San Lucas, Mexico",
      status: "upcoming"
    },
    {
      id: 7,
      date: "October 30 - November 2",
      name: "Butterfield Bermuda Championship",
      location: "Port Royal Golf Course, Southampton, Bermuda",
      status: "upcoming"
    }
  ];

  // Filter tournaments based on search query
  const filteredRecentEvents = recentEvents.filter(event =>
    event.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    event.location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredUpcomingEvents = upcomingEvents.filter(event =>
    event.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    event.location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="proskins-sidebar">
      {/* Video Thumbnail */}
      <h3 className="proskins-sidebar-title headingfont">Message From Pro$kins Founder</h3>
      <div className="video-thumbnail" onClick={openVideo}>
        <img 
          src="http://i3.ytimg.com/vi/8WC84NoicAE/hqdefault.jpg"
          alt="Welcome video" 
          className="video-image"
        />
        {/* <div className="play-button">▶</div> */}
        <div className="play-button"></div>
      </div>

      {/* Modal for Video */}
      {isVideoOpen && (
        <div className="video-modal" onClick={closeVideo}>
          <div className="video-container" onClick={(e) => e.stopPropagation()}>
            {/* Loader */}
            {isVideoLoading && (
              <div className="video-loader">
                <div className="spinner"></div>
              </div>
            )}
            <iframe
              src="https://www.youtube.com/embed/8WC84NoicAE?autoplay=1"
              title="YouTube video player"
              className="video-iframe"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              onLoad={() => setIsVideoLoading(false)}
            ></iframe>
            <button className="close-button" onClick={() => setIsVideoOpen(false)}>✕</button>
          </div>
        </div>
      )}

      {/* Recent Events Section */}
      <div className="proskins-sidebar-section">
        <h3 className="proskins-sidebar-title headingfont">UPCOMING EVENTS</h3>

        <div className="proskins-sidebar-item" onClick={() => toggleSection('recentEvents')}>
          <span><img
            className="headericon"
            src={`${process.env.PUBLIC_URL}/golfman.png`}
            alt="Notification"
          /></span>
          <span className="proskins-sidebar-event-name">PGA Tour</span>
          <span style={{marginLeft: 'auto'}}>
            {expandedSections.recentEvents ? '▼' : '▲'}
          </span>
        </div>

        {expandedSections.recentEvents && (
          <div className="proskins-sidebar-events">
            <BlockContent identifier="pga-tour" />
          </div>
        )}
      </div>

        {/* Upcoming Events Section */}
      <div className="proskins-sidebar-section">
        <h3 className="proskins-sidebar-title headingfont">PAST EVENTS</h3>
        <div className="proskins-sidebar-events">
          <BlockContent identifier="past-events"/>
        </div>
        </div>
      </div>
      );
      };

      export default LeftSidebar;
